import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Twitter embeds without JavaScript, pt1 – #CodeWithSwiz 29",
  "description": "Continuing our quest for better Lighthouse scores, more reader privacy, and less JavaScript we attacked the next biggest culprit 👉 Twitter.",
  "published": "2021-05-04T00:00:00.000Z",
  "categories": "CodeWithSwiz, Technical, Twitter, Gatsby, Livecoding",
  "hero": "./img/screenshot-1620145256168.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Continuing our `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/2-quick-tips-for-250percent-better-lighthouse-scores-codewithswiz-28/"
      }}>{`quest for better Lighthouse scores, more reader privacy, and less JavaScript`}</a>{`, today we attacked the next biggest culprit 👉 Twitter.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/b456544768c92742c998f1c53975a3f4/25e47/JhOjnXjpg3bfa13.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "72.6457399103139%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'291\\'%20viewBox=\\'0%200%20400%20291\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M8%208c-2%203%200%205%203%205%201-1%202%200%202%201l2-1h11l1-1h1l4%201%204-1h1c1%202%2014%201%2015-1%200-2-1-2-4-2H28L12%208H8m97%201h-7c-6%200-8%200-9%202-1%201-1%201-1-1h-2l-1-1c-4%200-1%204%203%204l4%201h1l2-1h5l1-1h14c1%201%204%201%204-1s-6-3-8-1h-3l-1-1h-2M72%2042l-1%202-1%201h7l2-1%202%201%206%201%205-1h1l1-1%201%201c2%202%202%202%203%201%201-2%202-2%202-1%200%202%201%200%202-2%200-1-1-2-5-2l-4%201h-5c1-2%200-2-1-2l-2%201-6%201-5-1-1-1-1%202m145%201l3%201a72993%2072993%200%2001-3-1M72%2069l-1%202-1%201c1%201%207%200%207-1h4c1%202%2012%202%2013%200h1c2%203%207%201%207-1s-1-2-6-2l-7%201h-1v-1c1-1%201-1-1-1l-2%202-1%201-4-1-5%201-1-1-1-2-1%202m109-1h-6l-6%201h-4c0-2-2-1-2%201h-1c0-3-9-2-9%200%200%203%204%203%206%202h3c1%201%208%200%209-1h1l1%201h3c3%201%207%200%207-2s-2-4-2-2m63%200c-3%205-2%205%2016%205l17-1c1-1%200-2-1-3-2-1-2-1-2%201s0%202-1%201c-1-3-10-4-11-1%200%203-2%203-2%200s-5-3-5%200c-1%202-1%202-1%200%200-3-7-3-7%200s-2%202-2-1l-1-1m57%2016l-1%203%203%202h3l2-1h2c2%202%206%201%206%200h2c0%202%201%202%201%201h5c5%201%206%201%206-2%200-1-1-2-10-2l-14-1h-5m-140%201l-3%201h-1l-2-1-1%202%201%202c0%202%2015%202%2016%200h1l15%201h53v-2c0-3-3-4-3-1h-1c0-2-2-3-6-2h-3l-4%202h-2l-1-2h-1c-2-2-3%200-2%202l-1%202c-1%200-2-1-2-3-1-2-1-2-1%200-1%202-3%203-2%200%200-2%200-2-4-1l-4%201-2-1c-1-1-7%200-7%201h-7l-1-1c-1-1-1%200-1%201l-1%202h-1l-1%201c-1%200-2-1-1-2%200-2%200-2-2-2l-2%201c-8-1-9-1-8%201l-1%202-2-2c0-3-1-3-5-2m183%200h-5c-3%200-5%201-5%202l1%201h1c-3%201%209%202%2013%201h3c5%202%2011%200%2011-3%200-2%200-2-5-1l-7%201h-2l-5-1M147%2097v4h18c13%200%2018-1%2017-2l1-1c1-1%201-1%201%201%200%201%200%202%206%202%205%200%206-1%206-3l1-2v2c0%202%200%203%207%203s7%200%207-3v-3h-16c-14%200-16%201-15%202h-2l-1%202v-3c0-1-2-2-2%200l-3%201-1-1-1-1-1%201h-1c0-2-1-2-1-1h-19c-1-1-1%200-1%202M28%20156c-1%203%200%205%202%203h29l3-1h18c0-2%200-2%201-1%201%202%2012%203%2012%201l2-1%201%201%208%201c8%200%209%200%208-2h1c1%202%208%202%208%201%201-1-1-5-2-4h-14l-3%201h-5l-4%201H64c-2%200-3%200-4-2h-1l-5%201h-6l-2-1H35c-1-1-1-1-1%201%200%201%200%202-1%201l-1-1-2-1-2%202m291%208c-7%202-15%206-16%209s-1%206%201%206v-1l1-2%202-2h1c0%203%2012%202%2013-1%200-2-3-4-4-1%200%202-2%203-2%201s-2-4-3-2l-2-1c-3-3%2020-6%2048-5%2016%200%2022%203%2019%209l-1%203v-3c0-4-3-5-5-2l-2%201-1-2c-1%200-2%201-2%203s0%202%201%201h1l4%201%204%201c1%202%203-3%203-6%200-7-5-8-32-8-20-1-23-1-28%201m-296%207l-1%203c0%202%200%202%201%201h1c0%202%206%201%207-1h1c0%202%2010%203%2013%201h1l3%201%202-1h21c0-2%200-2%201-1a182%20182%200%200046%201c0%202%203%201%203%200%202-4-5-6-13-4h-2l-5-1-5%202-2%202-1-1-3-1-4-1-2%201c-1%202-2%202-2%201-1-2-13-2-14%200%200%202-2%201-2-1s0-2-1-1H56l-5%201h-6c-1%201-1%200-1-1H23m349%209c-4%202-10%203-20%201-12-2-20-2-32%200-8%202-9%202-12%201-2-2-3-2-3-1l2%202%202%201c-1%202%2024%203%2042%202%2010-1%2010-1%2022%203%2013%204%2018%207%2016%209-3%203-22%207-44%2010-14%202-40%200-45-5h-4l13%206a146%20146%200%200081-9c4-4%200-7-14-12-11-4-11-4-2-7l2-2c0-1-1-1-4%201M22%20190v2h2l7-1h1c1%202%2010%202%2013%201h1c1%201%205%200%205-1h1l7%201c8%201%209%200%208-2%200-2-1-2-5-1l-5-1H46c0-1-1-1-1%201h-1c0-2%200-2-1-1H24l-2%202m60-2l-5%201c-7%200-9%200-8%202l1%201h6c1-2%202-2%202-1%201%201%2013%202%2015%201h5l4-1h1c2%202%209%202%2010%200h3c1%201%208%202%2013%201v-3l-2-1h-21l-14%201h-4l-5-1h-1m49%201l2%203v-2l1-2v2c0%202%203%203%203%201h1c1%202%2017%202%2017%200h1c1%202%204%202%2012%201h3c1%201%204%200%204-1h1c2%202%2019%202%2020%200h1l3%201c2%200%202%200%202-3%200-1%200-2-1-1h-21l-5%201h-5c-1%202-4%201-4-1h-1l-3%201h-2c-2%203-3%202-3%200s0-2-1-1l-5%201-3-1-1-1-2%201-5%201-4-1-3-1c-3%200-3%200-2%202M23%20215l-1%203c0%201%200%202%201%201h1c1%202%206%200%206-2%201-1%201-1%201%201%200%201%201%202%205%202l4-1h3l1-1c1%201%202%202%205%202h7c2%201%203-1%202-3l-2-2h-1c-1-1-1%200-1%201%200%203-2%203-2%200%200-2-10-3-11-1h-1l-2-1-3%201H23m6%2030v2l-1%202c-1%201%200%201%202%201h4l9-1h1l1%201%201-1%201-3%201%202v1c2-2%202-2%202%200h3l5%201c4%200%204%200%204-3%200-2-1-2-4-2l-4%201h-1c-1-2-5-2-7%200-1%201-1%201-3-1H29m294%202c-1%203-7%206-16%207-20%202-19%2011%203%2020%207%203%207%204%207%207%201%203%203%204%204%200l1-2%201%203%201%201h1c3%202%208%201%208-1s1-2%209-2c9-1%2010%200%2010%202h2l2%201c2%200%202-1%202-2-1-3%200-3%203-3l21-7v-3c-1-4-16-13-25-16-4-1-6-3-2-2%203%200%204-1%203-4s-6-2-7%202c0%202%200%202-1%200l-2-3v2c0%202%200%202-3%202l-8-1c-3%200-4%200-4-2-1-2-4-3-4%200h-1c-2-2-5-2-5%201m-254%200c-1%203-1%203%201%202h3l16%201c4%200%205%200%205-2h1c0%201%201%202%203%202s3%200%202-2c0-2-3-3-3-1h-1c-1-2-26-2-27%200m255%204c-5%201-7%203-3%203l17%201-14%201h-20c-11%201-13%205-5%2011%2017%2012%2040%2014%2073%206%209-2%2010-3%207-7l-3-1c0%203-10%202-10-1-1-2%200-4%201-2h2c2-2%201-2-5-5-12-6-28-8-40-6M48%20262l-2%201H34c-11%200-12%200-12%202s0%202%201%201l1-1c0%202%201%202%205%202l6%201h1c1-1%202-2%206-1%203%200%205%200%206-2h1c0%201%201%202%205%202l5%201h2l8-1c5%200%207-1%207-2h1c0%201%201%202%203%202l2-2h1c1%202%2030%203%2031%201h1l2%201%201-2c0-3-2-5-3-3h-15c-3-2-7-1-8%202l-1%202-1-1c0-1-2-2-6-2l-9-1c-1-2-4%201-4%203%201%201%200%201-1%201l-2-2c0-1-1-2-7-1l-7-1h-1l-2%201-2-1h-1m83%200l-2%201-2%201c-1%203%207%204%207%201h1c1%202%204%202%205%200%200-3%202-3%201%200%200%202%200%202%201%201l1-1c1%202%202%202%204%202h4l2%201%202-1%202-2h1c0%202%201%202%203%201%206-1%204-2-8-3l-10-1-2-1-3%201h-7\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/b456544768c92742c998f1c53975a3f4/ca0a1/JhOjnXjpg3bfa13.webp 223w", "/static/b456544768c92742c998f1c53975a3f4/75680/JhOjnXjpg3bfa13.webp 445w", "/static/b456544768c92742c998f1c53975a3f4/8d1ba/JhOjnXjpg3bfa13.webp 890w", "/static/b456544768c92742c998f1c53975a3f4/3838e/JhOjnXjpg3bfa13.webp 1335w", "/static/b456544768c92742c998f1c53975a3f4/e11e5/JhOjnXjpg3bfa13.webp 1780w", "/static/b456544768c92742c998f1c53975a3f4/da7ce/JhOjnXjpg3bfa13.webp 1896w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/b456544768c92742c998f1c53975a3f4/853b2/JhOjnXjpg3bfa13.jpg 223w", "/static/b456544768c92742c998f1c53975a3f4/0a4fe/JhOjnXjpg3bfa13.jpg 445w", "/static/b456544768c92742c998f1c53975a3f4/7f80b/JhOjnXjpg3bfa13.jpg 890w", "/static/b456544768c92742c998f1c53975a3f4/dc6ba/JhOjnXjpg3bfa13.jpg 1335w", "/static/b456544768c92742c998f1c53975a3f4/2d2e5/JhOjnXjpg3bfa13.jpg 1780w", "/static/b456544768c92742c998f1c53975a3f4/25e47/JhOjnXjpg3bfa13.jpg 1896w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/jpeg"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/b456544768c92742c998f1c53975a3f4/7f80b/JhOjnXjpg3bfa13.jpg",
              "alt": "JhOjnXjpg3bfa13",
              "title": "JhOjnXjpg3bfa13",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`560KB of JavaScript to display unchanging tweets 😱`}</p>
    <lite-youtube {...{
      "videoid": "t11UusgcC68",
      "videostartat": "0"
    }}></lite-youtube>
    <p><em parentName="p">{`CodeWithSwiz is a weekly live show. Like a podcast with video and fun hacking. Focused on experiments and open source. `}<a parentName="em" {...{
          "href": "https://youtube.com/swizecteller"
        }}>{`Join live Tuesday mornings`}</a></em></p>
    <h2 {...{
      "id": "how-tweet-embeds-work"
    }}>{`How tweet embeds work`}</h2>
    <p>{`Twitter uses the `}<a parentName="p" {...{
        "href": "https://oembed.com/"
      }}>{`oEmbed Protocol`}</a>{` to specify embeds. A request to `}<inlineCode parentName="p">{`https://publish.twitter.com/oembed?url=<tweet_url>`}</inlineCode>{` returns the HTML to use and some metadata.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`{
  url: 'https://twitter.com/AdamRackis/status/1388192278884331530',
  author_name: 'Adam Rackis',
  author_url: 'https://twitter.com/AdamRackis',
  html: '<blockquote class="twitter-tweet" data-dnt="true"><p lang="en" dir="ltr">My man <a href="https://twitter.com/Swizec?ref_src=twsrc%5Etfw">@Swizec</a> went and sent me a signed first edition of this soon to be classic 👊 <a href="https://t.co/Gw8cTIY7pH">pic.twitter.com/Gw8cTIY7pH</a></p>&mdash; Adam Rackis (@AdamRackis) <a href="https://twitter.com/AdamRackis/status/1388192278884331530?ref_src=twsrc%5Etfw">April 30, 2021</a></blockquote>\\n',
  width: 550,
  height: null,
  type: 'rich',
  cache_age: '3153600000',
  provider_name: 'Twitter',
  provider_url: 'https://twitter.com',
  version: '1.0'
}
`}</code></pre>
    <p>{`Put that HTML on your page and it renders as a quote.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/ed6e4acf989afeb381beb034db1cf130/26a94/Plain-HTML-tweetg6dee9.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "52.017937219730946%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'208\\'%20viewBox=\\'0%200%20400%20208\\'%20preserveAspectRatio=\\'none\\'/%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/ed6e4acf989afeb381beb034db1cf130/ca0a1/Plain-HTML-tweetg6dee9.webp 223w", "/static/ed6e4acf989afeb381beb034db1cf130/75680/Plain-HTML-tweetg6dee9.webp 445w", "/static/ed6e4acf989afeb381beb034db1cf130/8d1ba/Plain-HTML-tweetg6dee9.webp 890w", "/static/ed6e4acf989afeb381beb034db1cf130/5f375/Plain-HTML-tweetg6dee9.webp 1102w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/ed6e4acf989afeb381beb034db1cf130/e92b6/Plain-HTML-tweetg6dee9.png 223w", "/static/ed6e4acf989afeb381beb034db1cf130/e66bf/Plain-HTML-tweetg6dee9.png 445w", "/static/ed6e4acf989afeb381beb034db1cf130/4ef49/Plain-HTML-tweetg6dee9.png 890w", "/static/ed6e4acf989afeb381beb034db1cf130/26a94/Plain-HTML-tweetg6dee9.png 1102w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/ed6e4acf989afeb381beb034db1cf130/4ef49/Plain-HTML-tweetg6dee9.png",
                "alt": "Plain HTML tweet",
                "title": "Plain HTML tweet",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Plain HTML tweet`}</figcaption>{`
  `}</figure></p>
    <p>{`Works fine, doesn't look great.`}</p>
    <p>{`Twitter's embed JavaScript – which you load globally – looks for `}<inlineCode parentName="p">{`<blockquote>`}</inlineCode>{` elements with the `}<inlineCode parentName="p">{`.twitter-tweet`}</inlineCode>{` class and turns them into iframes. Yes a whole iframe for each tweet.`}</p>
    <p><img parentName="p" {...{
        "src": "/1b27f01659c7a1c7a0336552894adfab/Blockquotes-become-embedded-tweetsji6492.gif",
        "alt": "Blockquotes become embedded tweets"
      }}></img></p>
    <p>{`Keep watching, they turn `}<em parentName="p">{`eventually`}</em></p>
    <p>{`Slow and looks bad. Each of those tweets, an iframe, runs 20+ requests, transfers over 1.5MB of data, and runs who knows how many ad trackers 💩`}</p>
    <h2 {...{
      "id": "how-were-fixing-it"
    }}>{`How we're fixing it`}</h2>
    <p>{`Inspiration for this hack comes from @wongmjane. Best I can tell, she didn't opensource her code. Gonna share mine when it's ready ✌️`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Tweets embed on my blog are now statically-generated as part of the page and its images are optimized using Next.js 10’s <Image /> component`}<br parentName="p"></br><br parentName="p"></br>{`Meaning:`}<br parentName="p"></br>{`- the tweets are available at page load`}<br parentName="p"></br>{`- no more cumulative layout shift (page jumping around) caused by loading embed tweets `}<a parentName="p" {...{
          "href": "https://t.co/fWCpiNN4Bo"
        }}>{`pic.twitter.com/fWCpiNN4Bo`}</a></p>{`— Jane Manchun Wong (@wongmjane) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/wongmjane/status/1330273157245243394"
      }}>{`November 21, 2020`}</a></blockquote>
    <p>{`Gonna replace the twitter machinery with custom CSS+HTML. No client-side code required.`}</p>
    <p>{`We got pretty far:`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/56b8dabb702484377566ad50e24f0d12/e72de/Static-tweet-no-client-side-JavaScript5fch0i.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "33.6322869955157%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'135\\'%20viewBox=\\'0%200%20400%20135\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M25%2016c-6%202-9%208-9%2015%200%2011%208%2016%2011%208%201-2%201-2%202-1s0%202-1%203c-2%202-2%202%200%204%203%203%205%203%206%200s2-3%204-2c3%202%207-2%208-7s1-5-1-6h-2l2-2c2-2%202-2%201-4l-3-3-4-3c-3-3-9-4-14-2m54%2048c-2%201-1%204%202%205l2%201c0%202-2%202-3%201-2-2-3-1-2%201%201%201%201%201-1%201l-2%201%2021%201h22v-3c0-2-1-2-2-1-1%202-4%200-3-3h3c2%200%202%200%201-2-3-2-5%200-5%204%201%202%200%203-1%203v-1l-2-1h-2c-1-1%200-1%201-1%203%200%204-2%201-4-2-1-4%201-4%205%201%202%200%202-1%201-3-1-3-1-1-3l1-3h-3c-3%200-3%200-1%201l2%201-3%202-2%203v-4c0-4-1-4-1%201%200%202-1%203-2%203v-7l-1%202-1%201-1-1c0-2-1-2-3%200h-1l-1-2-1%201c2%205%202%206%200%206s-2%200-1-2v-2c-5-3-6-4-3-4h3c-1-2-4-2-5-1m150%2052c0%205%200%205-1%202%200-4-1-4-1-3l-1%204c1%201%200%202-1%202-3%200-3-4%200-6%201-1%201-1-1-1s-2%201-2%204l-1%203-1-3c0-3%200-4-3-4s-3%200-3%204c0%205%201%206%202%204h1l16%201h17v-5c0-7-4-10-6-4v5c1%202%201%202-1%202-1%200-2-1-2-5s0-4-2-4l-3%201h2c2%200%203%202%201%202v2c2%201%202%202%201%202h-2c-2-2-3-1-2%201%201%201%201%201-2%201s-3%200-3-5c0-7-2-6-2%200m29-3h1l3%201c0%202-5%207-6%207l-2%201c-1%201%205%201%2015%201h17l-1-5-1-6-3%201%201%201c1-1%201%201%201%203v4l-3-1c-4%200-5-1-3-3%204-4%201-8-3-5-1%202-1%202%201%201h3c0%202-6%208-7%208v-1c2-2%201-7-1-8-4-3-7%205-4%208%201%201%201%201-1%201l-4-1%201-3c3-4-1-9-4-4\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/56b8dabb702484377566ad50e24f0d12/ca0a1/Static-tweet-no-client-side-JavaScript5fch0i.webp 223w", "/static/56b8dabb702484377566ad50e24f0d12/75680/Static-tweet-no-client-side-JavaScript5fch0i.webp 445w", "/static/56b8dabb702484377566ad50e24f0d12/8d1ba/Static-tweet-no-client-side-JavaScript5fch0i.webp 890w", "/static/56b8dabb702484377566ad50e24f0d12/40d0b/Static-tweet-no-client-side-JavaScript5fch0i.webp 1198w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/56b8dabb702484377566ad50e24f0d12/e92b6/Static-tweet-no-client-side-JavaScript5fch0i.png 223w", "/static/56b8dabb702484377566ad50e24f0d12/e66bf/Static-tweet-no-client-side-JavaScript5fch0i.png 445w", "/static/56b8dabb702484377566ad50e24f0d12/4ef49/Static-tweet-no-client-side-JavaScript5fch0i.png 890w", "/static/56b8dabb702484377566ad50e24f0d12/e72de/Static-tweet-no-client-side-JavaScript5fch0i.png 1198w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/56b8dabb702484377566ad50e24f0d12/4ef49/Static-tweet-no-client-side-JavaScript5fch0i.png",
                "alt": "Static tweet, no client-side JavaScript",
                "title": "Static tweet, no client-side JavaScript",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Static tweet, no client-side JavaScript`}</figcaption>{`
  `}</figure></p>
    <p>{`Looks like a tweet, lacks picture embeds and likes, the avatar is faked.`}</p>
    <h2 {...{
      "id": "how-static-tweet-embed-works"
    }}>{`How static-tweet-embed works`}</h2>
    <p>{`At the core of my approach is the `}<a parentName="p" {...{
        "href": "https://github.com/MichaelDeBoey/gatsby-remark-embedder"
      }}>{`gatsby-remark-embedder`}</a>{` plugin. Runs embeds when you build your site, supports grabbing oembed data, has built-in caching.`}</p>
    <p><em parentName="p">{`And`}</em>{` you can hook into the embed process with custom plugins. 🤘`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// gatsby-config.js

// ...
{
resolve: "gatsby-remark-embedder",
options: {
    // StaticTwitterEmbed is new
  customTransformers: [YoutubeTransformer, StaticTwitterEmbed],
  services: {
    Instagram: {
      accessToken: process.env.INSTAGRAM_OEMBED_TOKEN,
    },
  },
},
`}</code></pre>
    <p>{`The `}<inlineCode parentName="p">{`StaticTwitterEmbed`}</inlineCode>{` plugin doesn't do much yet – detects tweets, spits out `}<inlineCode parentName="p">{`oembed`}</inlineCode>{` data, returns hello world.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`/src/ESTabcdeeiimrttttw.js;

const official = require("gatsby-remark-embedder/dist/transformers/Twitter");
const {
  fetchOEmbedData,
} = require("gatsby-remark-embedder/dist/transformers/utils");

async function getHTML(url) {
  const twitterUrl = url.replace("events", "moments");

  const oembed = await fetchOEmbedData(
    \`https://publish.twitter.com/oembed?url=\${twitterUrl}&dnt=true&omit_script=true\`
  );

  console.log(oembed);

  return \`<p>Hello world</p>\`;
}

module.exports = {
  getHTML,
  shouldTransform: official.shouldTransform,
};
`}</code></pre>
    <p>{`Much of the code comes from the original Twitter transform. No need to rewrite `}<inlineCode parentName="p">{`shouldTransform`}</inlineCode>{` (detects twitter links), or the `}<inlineCode parentName="p">{`fetchOEmbedData`}</inlineCode>{` functions.`}</p>
    <p>{`Returning `}<inlineCode parentName="p">{`<p>hello world</p>`}</inlineCode>{` helps verify the plugin lives.`}</p>
    <h2 {...{
      "id": "creating-a-static-tweet"
    }}>{`Creating a static tweet`}</h2>
    <p>{`Rebuilding Gatsby for every change would be slow. We used a static HTML file instead.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<div id="target"></div>

<style></style>

<script>
  const oembed = { ... }

  const html = oembed.html

  document.getElementById('target').innerHTML = html
</script>
`}</code></pre>
    <p>{`First stab showed that an HTML blockquote shows up when you take it from oembed data and inject on the page. Old school vanilla JavaScript :)`}</p>
    <p>{`After that it's a schlep.`}</p>
    <p>{`Take a tweet iframe's URL, render in a tab, `}<del parentName="p">{`steal`}</del>{` borrow CSS with your browser devtools. Add custom HTML when necessary.`}</p>
    <p>{`We've got this for building the HTML:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const handle = oembed.author_url.replace("https://twitter.com/", "");
// TODO: make API call
const authorImg =
  "https://pbs.twimg.com/profile_images/1183169082243375104/FwXKVe5H_x96.jpg";

const author = \`<a class="author" href="\${oembed.author_url}"><img src="\${authorImg}" /><b>\${oembed.author_name}</b>@\${handle}</a>\`;

const tweet = oembed.html.replace(
  /pic.twitter.com\\/(\\w+)/,
  '<img src="https://pic.twitter.com/$1" />'
);

const html = \`<div class="static-tweet-embed">\${author}\${tweet}</div>\`;
`}</code></pre>
    <p>{`Can't use React because there's no React inside `}<inlineCode parentName="p">{`gatsby-remark-embedder`}</inlineCode>{`. Gotta build a string 😅`}</p>
    <p>{`Add a bunch of borrowed CSS and you get a decent-looking embed. Main thing was to find the font styles, colors, and border.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-css"
      }}>{`div.static-tweet-embed {
  display: flex;
  flex-direction: column;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica,
    Arial, sans-serif;
  max-width: 550px;
  width: 100;
  margin-top: 10px;
  margin-bottom: 10px;
  border: 1px solid rgb(196, 207, 214);
  border-radius: 12px;
  padding: 12px 16px 4px 16px;
}
`}</code></pre>
    <h2 {...{
      "id": "and-then-we-got-stuck"
    }}>{`And then we got stuck`}</h2>
    <p>{`You can't guess the avatar URL from someone's username, you can't guess image embed URLs from the HTML, and you don't get info about likes and retweets.`}</p>
    <p>{`💩`}</p>
    <p>{`Next week, we're gonna use the Twitter API to solve that problem`}</p>
    <p>{`Cheers,`}<br />{`
~Swizec`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      